import { useGetPublicDocumentsQuery } from '../state/api';
import AboutPage from './about-page';

const AboutPageContainer = () => {
  const { data: publicDocumentsData } = useGetPublicDocumentsQuery();
  const publicDocuments = publicDocumentsData?.files || [];

  return <AboutPage publicDocuments={publicDocuments} />;
};

export default AboutPageContainer;
